.customer-lead-step-sales-tax-info__container {
  flex: 1;
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;

  padding: 24px 0 0;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__container__row {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__controls {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;

  gap: 32px;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__sales-tax-files {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;

  gap: 16px;

  padding: 24px 0 0;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__add-sales-tax-file__button {
  cursor: pointer;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  gap: 8px;

  width: 320px;
  height: 180px;
  border-radius: 8px;
  border: 1px dashed #CCCFD8;

  &:hover {
    border-color: #0082F9;
  }
}

.customer-lead-step-sales-tax-info__container  .customer-lead-step-sales-tax-info__add-photo__text {
  color: #0082F9;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__info-icon {
  padding: 0 10px;
  border-radius: 50%;
  border: 1px solid #DADADA;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__error-icon {
  color: var(--color-danger-medium);
  border-color: var(--color-danger-medium);
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__info-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  & a {
    text-decoration: underline dashed;
  }
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__images-preview {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  align-items: center;

  gap: 16px 24px;
}

.customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__error-message {
  position: relative;
}


@media screen and (width <= 640px) {
  .customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__controls {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .customer-lead-step-sales-tax-info__container .customer-lead-step-sales-tax-info__add-sales-tax-file__button {
    width: unset;
  }
}


